import _ from "lodash";
import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import { IComponentWithValidatedForm } from "../../../../components/validation";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import { ReactHelper, Utility } from "../../../../utils";

interface OwnProps {
    api: Api;
    formComponent: IComponentWithValidatedForm;
    itemIdxToToggle?: number;
    loading?: boolean;
    namePrefix: string;
}

interface OwnState {
    editing: { [index: number ]: boolean; };
}

export class CommercialInterestEditor extends React.Component<OwnProps, OwnState> {

    private _searchTimeout: NodeJS.Timer;
    private _initiallyOpen = true;

    public constructor(props: any) {
        super(props);
        this.state = {
            editing: {},
        };
    }

    public componentDidMount() {
        this.initialChecks();
    }

    public componentDidUpdate(prevProps: Readonly<OwnProps>) {
        this.initialChecks(prevProps);
    }

    public render() {
        const modelItems = this.props.formComponent.getFormModel<Forms.FinancialDisclosure.FinancialDisclosureData>().data.commercialInterests;
        const relOpts = M.FinancialDisclosure.FDRelationshipTypes.Values.map((x) => ({ value: x.id, label: `${x.name} (${x.code})` }));
        const compOpts = M.FinancialDisclosure.FDCompensationTypes.Values.map((x) => ({ value: x.id, label: `${x.name} (${x.code})` }));
        const addText = modelItems.filter((x) => !x.isDelete).length === 0 ? "commercial interest" : "another";

        // Build link editors
        const sortedItems = _.orderBy(modelItems, "index");
        const items = sortedItems.map((item, i) => {
            const isEditing = !!this.state.editing[item.index];
            const errors = this.props.formComponent.getFieldErrors(`${this.props.namePrefix}[${i}]`);
            const display = isEditing
                ? <Comp.Generic.WrapperLess>
                    <Comp.Editors.SelectField
                        formComponent={this.props.formComponent}
                        compact
                        isAsync
                        name={`${this.props.namePrefix}[${i}].company`}
                        select={{
                            className: "txt",
                            ignoreAccents: false,
                            ignoreCase: false,
                            loadOptions: (search: string) => this.searchOrg(search),
                            placeholder: "",
                        }}
                    />

                    <Comp.Editors.CheckboxField
                        formComponent={this.props.formComponent}
                        name={`${this.props.namePrefix}[${i}].isSpouse`}
                        compact
                        label="Spouse or partner relationship"
                    />

                    <Comp.Editors.SelectField
                        formComponent={this.props.formComponent}
                        name={`${this.props.namePrefix}[${i}].relationships`}
                        compact
                        select={{
                            // cache: false,
                            closeOnSelect: false,
                            ignoreCase: false,
                            multi: true,
                            options: relOpts,
                            placeholder: "Select as many as needed",
                            optionRenderer: (opt: M.Generic.ReactSelectOption) => {
                                const checked = item.relationships.map((x) => x.value).indexOf(opt.value) > -1;
                                return <Comp.Generic.WrapperLess>
                                    <label><input checked={checked} type="checkbox" onChange={(e) => {}} /> {opt.label}</label>
                                </Comp.Generic.WrapperLess>;
                            },
                        }}
                    />

                    <Comp.Editors.SelectField
                        formComponent={this.props.formComponent}
                        name={`${this.props.namePrefix}[${i}].compensations`}
                        compact
                        select={{
                            // cache: false,
                            closeOnSelect: false,
                            ignoreCase: false,
                            multi: true,
                            options: compOpts,
                            placeholder: "Select as many as needed",
                            optionRenderer: (opt: M.Generic.ReactSelectOption) => {
                                const checked = item.compensations.map((x) => x.value).indexOf(opt.value) > -1;
                                return <Comp.Generic.WrapperLess>
                                    <label><input checked={checked} type="checkbox" onChange={(e) => {}} /> {opt.label}</label>
                                </Comp.Generic.WrapperLess>;
                            },
                        }}
                    />

                    <p>
                        <a className="btn btn-default" href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleEditing(item.index); }}>
                            Save
                        </a>
                        <a className="btn btn-link" href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleEditing(item.index); }}>
                            Cancel
                        </a>
                    </p>
                </Comp.Generic.WrapperLess>
                : <Comp.Generic.WrapperLess>
                    <p>
                        {item.company && item.company.label ? item.company.label : "Unknown company"}{item.isSpouse ? " (Spouse or partner relationship)" : ""}
                        <br />Type of relationship: {Utility.joinSkipEmpty(item.relationships.map((x) => x.label), ", ")}
                        <br />Nature of compensation: {Utility.joinSkipEmpty(item.compensations.map((x) => x.label), ", ")}
                    </p>
                    <p>
                        <a className="btn btn-default" href="#" onClick={(e) => { ReactHelper.emptyClick(e); this.toggleEditing(item.index); }}>
                            <Comp.Generic.Icon icon="pencil" /> Edit
                        </a>
                    </p>
                    <input type="hidden" name={`${this.props.namePrefix}[${i}]`} />
                    <Comp.Editors.FormFieldErrors errors={errors} />
                </Comp.Generic.WrapperLess>;

            return <li key={i} className="list-builder-item" style={{ display: item.isDelete ? "none" : "block" }}>
                <div className="list-builder-fields">
                    {display}
                </div>
                <BS.Button bsStyle="danger" className="remove-trigger" onClick={() => this.onDelete(item.index)} title="Delete commercial interest">
                    <i className="fa fa-times"></i>
                </BS.Button>
            </li>;
        });

        return <div>
            <Comp.Editors.FormField label="" name={this.props.namePrefix}>
                <ul className="list-builder">
                    {items}
                </ul>
            </Comp.Editors.FormField>

            <Comp.Editors.FormField name="">
                <BS.ButtonGroup>
                    <BS.Button onClick={() => this.onAdd()}><i className="fa fa-plus"></i> Add {addText}</BS.Button>
                </BS.ButtonGroup>
            </Comp.Editors.FormField>
        </div>;
    }

    private hideEditForms() {
        this.setState({ ...this.state, editing: {} });
    }

    private initialChecks(prevProps?: Readonly<OwnProps>) {
        const FM = this.props.formComponent.getFormModel() as Forms.FinancialDisclosure.FinancialDisclosure;
        if (this._initiallyOpen && FM.data.commercialInterests.length === 1) {
            // if landing on page initially, show mini form
            const idx = FM.data.commercialInterests[0].index;
            this._initiallyOpen = false;
            this.toggleEditing(idx);
        }

        if (prevProps && prevProps.loading && !this.props.loading) {
            // if FD data load finish detected, hide all mini forms.
            this.hideEditForms();
        }

        if (prevProps
            && prevProps.itemIdxToToggle !== this.props.itemIdxToToggle
            && this.props.itemIdxToToggle !== undefined
            && this.props.itemIdxToToggle >= 0) {
            // if a new item was added, show its mini form
            this.toggleEditing(this.props.itemIdxToToggle);
        }
    }

    private onAdd() {
        const formModelData = this.props.formComponent.getFormModelData<Forms.FinancialDisclosure.FinancialDisclosureData>();
        formModelData.commercialInterests.push({
            ...Forms.FinancialDisclosure.DefaultCommercialInterest,
            index: formModelData.commercialInterests.length,
        });
        this.props.formComponent.updateFormModelData(formModelData);
    }

    private onDelete(idx: number) {
        const formModelData = this.props.formComponent.getFormModelData<Forms.FinancialDisclosure.FinancialDisclosureData>();
        const item = _.find(formModelData.commercialInterests, (s, i) => s.index === idx);

        if (item)
            item.isDelete = true;

        this.props.formComponent.updateFormModelData(formModelData);
    }

    private searchOrg(search: string) {
        if (!search || search.length < 2)
            return Promise.resolve({ options: [] });

        return new Promise((resolve, reject) => {
            // delay the ajax call as to not make a call for each letter typed.
            if (this._searchTimeout !== undefined)
                clearTimeout(this._searchTimeout);

            this._searchTimeout = setTimeout(() => {
                const queryParams = {
                    queryParams: {
                        query: search,
                        includeNonMembers: false,
                    },
                };

                // for adding new value
                const newOrg: M.Generic.ReactSelectOption =
                    Utility.toReactSelectOption({}, search, search);

                this.props.api.callApi<M.Org.BasicOrganizationProfile[]>(Api.endpoints.org.search, queryParams)
                    .then((result) => {
                        if (result.isSuccess && result.data) {
                            let options = result.data.map((o) => {
                                return Utility.toReactSelectOption({}, o.name, o.name);
                            });

                            const newOrgMatch = _.find(options, (org) => {
                                return org.label.toLowerCase().trim() === newOrg.label.toLowerCase().trim();
                            });

                            if (newOrgMatch === undefined)
                                options = [newOrg, ...options];

                            options = [...options];
                            resolve({ options });
                        }
                        else
                            console.warn(result.errors.join("; "));
                    });
            }, 375);
        }).then((data) => {
            return data;
        });
    }

    private toggleEditing(idx: number) {
        const editing = { ...this.state.editing };
        editing[idx] = !!!editing[idx];
        this.setState({ ...this.state, editing });
    }
}



// WEBPACK FOOTER //
// ./src/containers/user/financialDisclosure/components/CommercialInterestEditor.tsx